import createVueComponent from '../createVueComponent';
export default createVueComponent('outline', 'square-root', 'IconSquareRoot', [["path",{"d":"M3 12h2l4 8l4 -16h8","key":"svg-0"}]]);